function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M27,0C12.0883179,0,0,12.0883179,0,27s12.0883179,27,27,27s27-12.0883179,27-27S41.9116821,0,27,0z M33.75,17.5315552h-2.4647827c-1.9329224,0-2.3062134,0.9966431-2.3062134,2.4529419v3.4718018h4.3618774l-0.5982666,5.0386963 h-3.7636108v12.6799927h-4.8068237V28.4949951H20.25v-5.0386963h3.9221802V19.486145 c0-4.3134155,2.434082-6.6611328,5.9880371-6.6611328c1.7028809,0,3.1654053,0.1384277,3.5897827,0.1993408V17.5315552z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "54px",
    height: "54px",
    viewBox: "0 0 54 54",
    style: {
      "enableBackground": "new 0 0 54 54"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/facebook.1f15acfe.svg";
export { SvgComponent as ReactComponent };